import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
var DangerouslySetInnerHtml = forwardRef(function (_ref, ref) {
  var html = _ref.html,
    _ref$element = _ref.element,
    Component = _ref$element === void 0 ? 'div' : _ref$element,
    className = _ref.className,
    onClick = _ref.onClick,
    children = _ref.children;
  return html ? jsx(Component, Object.assign({}, {
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: className,
    onClick: onClick,
    children: children
  })) : null;
});
export { DangerouslySetInnerHtml };